import React from 'react';
import PropTypes from 'prop-types';
import agreementImage from '../../img/agreement-contract.jpg';

import './modal-agreement.scss';

const ModalAgreement = ({ openModal, setOpenModal, setAllowPay, type, loadBtn }) => {

  const closeModal = () => {
    if (type === 'accounts') {
      setOpenModal({
        'open': false,
        'id': null,
        'url': null,
        'name': null,
      });
    }

    if (type === 'pay') {
      setOpenModal({
        'open': false,
        'url': null,
        'name': null,
        'method': null,
        'appointment': null
      });
    }

    document.body.classList.remove('open');
  };

  const setModalData = (data) => {
    setAllowPay(true);
    setOpenModal(data);
  };

  return (
    <div className={`modal-info agree-modal ${openModal.open ? 'open' : ''}`}>
      <div className="overlay" onClick={closeModal}></div>
      <div className="agree-modal__card" role="dialog" aria-modal="true" aria-labelledby="agree-modal-title">
        <button type="button" className="agree-modal__close" aria-label="Закрити" onClick={closeModal}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" style={{ fill: 'none' }} />
          </svg>
        </button>

        <img className="agree-modal__img" src={agreementImage} alt="" width="430" height="340" />

        <h3 className="agree-modal__title" id="agree-modal-title">
          Ви ознайомилися з умовами Договору публічної-оферти
        </h3>

        <p className="agree-modal__line">
          {openModal.name && (
            <button
              type="button"
              className="agree-modal__doc"
              onClick={() => window.open(openModal.url, '_blank', 'noopener')}
            >
              {openModal.name}
            </button>
          )}
          <span>і погоджуєтеся з його умовами?</span>
        </p>

        <p className="agree-modal__note">Оплата Вами рахунку означає погодження з умовами Договору.</p>

        <div className="agree-modal__btns">
          <button type="button" className="agree-modal__btn agree-modal__btn--no" onClick={closeModal}>Ні</button>
          <button
            type="button"
            className="agree-modal__btn agree-modal__btn--yes"
            disabled={Boolean(loadBtn)}
            onClick={() => setModalData(openModal)}
          >
            {loadBtn ? 'Зачекайте…' : 'Так'}
          </button>
        </div>
      </div>
    </div>
  );
};

ModalAgreement.propTypes = {
  openModal: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  setAllowPay: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  loadBtn: PropTypes.bool,
};

export default ModalAgreement;
